import Backbone from 'backbone';
import _ from 'underscore';

import PeerReviewSubmissionSummary from 'pages/open-course/peerReview/models/submissionSummary';

const PeerReviewSubmissionSummaries = Backbone.Collection.extend({
  model: PeerReviewSubmissionSummary,

  initialize(models: $TSFixMe, options: $TSFixMe) {
    this.metadata = options.metadata;
  },

  getItemLink() {
    return this.metadata.getBaseLink();
  },

  parse(data: $TSFixMe, options: $TSFixMe) {
    const summaries = _(data.submissionSummaries).map(function (summary) {
      const creator = _(data.userProfiles).findWhere({
        userId: summary.creatorId,
      });
      return _(summary).extend({ creator });
    });
    return summaries;
  },
});

export default PeerReviewSubmissionSummaries;
